"use client";

import { useIntl } from "react-intl";

import HighContrastSaturation from "assets/icons/high-contrast-saturation.svg";
import Saturation from "assets/icons/saturation.svg";
import { fontSizeButtons } from "components/A11yControls/helpers";
import type { A11yControlsProps } from "components/A11yControls/types";
import { useA11ySettings } from "components/A11yControls/useA11yControls";
import { cn } from "utils/helpers/cn";

const buttonStyles = cn(
    "flex items-center justify-center py-0 px-n2 border border-transparent text-f-primary cursor-pointer transition rounded",
    "hover:outline-hidden hover:ring-2 hover:ring-ring hover:ring-offset-0",
    "focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-0",
);

function A11yDropdown({ variant }: A11yControlsProps) {
    const { formatMessage } = useIntl();
    const { isHighContrast, toggleHighContrast, setFontSize } = useA11ySettings();

    return (
        <div
            className={cn(
                "flex items-stretch gap-n4 rounded-n2xl border border-gray2 bg-white px-n6 py-n3 text-f-primary shadow-controls",
                {
                    "border-0 bg-transparent p-0 shadow-none": variant === "simple",
                },
                "dark: border-background dark:bg-background dark:shadow-none",
            )}
        >
            {fontSizeButtons.map(({ value, label, textSize }) => (
                <button
                    key={value}
                    type="button"
                    data-test-id={`button-font-size-${value}`}
                    title={formatMessage({ id: label })}
                    aria-label={formatMessage({ id: label })}
                    onClick={() => setFontSize(value)}
                    className={buttonStyles}
                    style={{ fontSize: textSize }}
                >
                    A
                </button>
            ))}
            <button
                type="button"
                data-test-id="button-contrast"
                title={formatMessage({ id: "high_contrast" })}
                aria-label={formatMessage({ id: "high_contrast" })}
                onClick={() => toggleHighContrast()}
                className={buttonStyles}
            >
                {isHighContrast ? <HighContrastSaturation /> : <Saturation />}
            </button>
        </div>
    );
}

export default A11yDropdown;
